export const UPDATE_POST_COUNTERS = 'post/UPDATE_POST_COUNTERS';

export const updatePostCounters = payload => dispatch =>
  dispatch({
    type: UPDATE_POST_COUNTERS,
    payload,
  });
